import React from 'react';

const FEATURES = [
  { icon: '📊', title: 'Mining Dashboard', text: 'User-friendly interface to track your mining and earnings in one place.' },
  { icon: '⛏️', title: 'Daily Activation', text: 'Activate mining every 24 hours to earn XT Tokens on every active package.' },
  { icon: '🔄', title: 'Auto Extension', text: 'Missed mining days extend automatically so your package stays productive.' },
  { icon: '💰', title: 'Token Withdrawal', text: 'Withdraw your earnings any time above the platform minimum.' },
  { icon: '🔁', title: 'XT / USDT Swap', text: 'Convert between XT and USDT at the platform rate whenever you withdraw.' },
  { icon: '🎁', title: 'Level Rewards', text: 'Earn a share of every purchase across your 12-level downline (unlocks based on qualifying directs).' },
  { icon: '🔐', title: 'Secure Wallets', text: 'Non-custodial — connect Trust Wallet, MetaMask, or any Web3 wallet.' },
  { icon: '📈', title: 'Real-Time Stats', text: 'Live view of your mining, referrals, team, and reward history.' },
];

export default function Features() {
  return (
    <section id="features" className="section">
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div className="section-eyebrow">PLATFORM FEATURES</div>
          <h2 className="section-title">
            Everything You Need to <span className="text-gradient">Mine & Earn</span>
          </h2>
          <p className="section-subtitle" style={{ margin: '0 auto' }}>
            Built to make participation simple, transparent, and rewarding.
          </p>
        </div>

        <div className="features-grid">
          {FEATURES.map((f, i) => (
            <div key={i} className="feature-item">
              <div className="feature-icon">{f.icon}</div>
              <div className="feature-text">
                <h4>{f.title}</h4>
                <p>{f.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
